const date = { now: () => new Date() };

export default date;